import React from "react";
import Modal from "./Modal";
import PrimaryButton from "./PrimaryButton";
import SecondaryButton from "./SecondaryButton";
import { CloseOutlined } from "@ant-design/icons";

interface ConfirmAlertProps {
  visible: boolean;
  title: string;
  message: any;
  secondaryText: string | null;
  primaryText: string;
  secondaryAction: any;
  primaryAction: any;
  note?: string;
  onClose? : () => void
}
const ConfirmAlert: React.FC<ConfirmAlertProps> = ({
  visible,
  title,
  message,
  secondaryAction,
  secondaryText,
  primaryAction,
  primaryText,
  note,
  onClose
}) => {
  return (
    <Modal show={visible}>
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content app-card border-0 p-0">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
           {typeof onClose == 'function' && <CloseOutlined onClick={onClose} className="right" />}
          </div>
          <div className="modal-body col-wise py-1">
            <label dangerouslySetInnerHTML={{ __html: message }}></label>
            {note ? <label className="my-3 confirm-note">{note}</label> : ""}
          </div>
          <div className="modal-footer">
            {secondaryText !== null && (
              <SecondaryButton label={secondaryText || ""} disable={false} clicked={secondaryAction} />
            )}
            <PrimaryButton label={primaryText} disable={false} clicked={primaryAction} />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmAlert;
